module.exports = __webpack_public_path__ + "img/yishi3.97ac0a2b.jpg";